/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import * as Sentry from '@sentry/react';
import log from 'loglevel';

log.setLevel(log.levels.DEBUG);

const logger = {
  debug(message: string, ...arguments_: any[]) {
    console.debug(message, ...arguments_);
  },

  info(message: string, ...arguments_: any[]) {
    Sentry.addBreadcrumb({
      message,
      level: 'info',
      data: arguments_,
    });
  },

  warn(message: string, ...arguments_: any[]) {
    console.warn(message, ...arguments_);
  },

  error(message: string, ...arguments_: any[]) {
    console.error(message, ...arguments_);
  },

  log(message: string, ...arguments_: any[]) {
    console.log(message, ...arguments_);
  },
};

export default logger;
